import { AutoEvaluacionesErrorBoundary } from 'components/Error/Error'
import { PrivateRoute } from 'components/PrivateRoute/PrivateRoute'
import React from 'react'
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom'
import Preguntas from 'pages/Preguntas'
import Caracteristicas from 'pages/Caracteristicas'
import Dimension from 'pages/Dimension'
import Encuesta from 'pages/Encuesta'
import Escuela from 'pages/Escuela'
import CaracteristicaGrupoInteres from 'pages/CaracteristicaGrupoInteres'
import EvidenciaCumplimiento from 'pages/EvidenciaCumplimiento'
import Factor from 'pages/Factor'
import Indicador from 'pages/Indicador'
import Inicio from 'pages/Inicio'
import Login from 'pages/Login'
import ProgramasAcademicos from 'pages/ProgramasAcademicos'
import Prueba from 'pages/PruebaPagina'
import DetalleEncuesta from 'pages/DetalleEncuesta'
import PrevisualizacionEncuesta from 'pages/PrevisualizacionEncuesta'
import { RUTAS } from 'constants/constants'
import { CargarDatos } from 'pages/CargarDatos'

function App(p) {
  const handleReset = () => window.location.reload()

  return (
    <Router>
      <AutoEvaluacionesErrorBoundary onReset={handleReset}>
        <Switch>
          <Route exact path={RUTAS.LOGIN}>
            <Login />
          </Route>
          <PrivateRoute path={RUTAS.INICIO}>
            <Inicio />
          </PrivateRoute>
          <PrivateRoute path={RUTAS.CARGUE_DOCUMENTOS}>
            <CargarDatos />
          </PrivateRoute>
          <PrivateRoute path={RUTAS.PRUEBA}>
            <Prueba />
          </PrivateRoute>
          <PrivateRoute path={RUTAS.DIMENSION}>
            <Dimension />
          </PrivateRoute>
          <PrivateRoute path={RUTAS.FACTOR}>
            <Factor />
          </PrivateRoute>
          <PrivateRoute path={RUTAS.CARACTERISTICAS}>
            <Caracteristicas />
          </PrivateRoute>
          <PrivateRoute path={RUTAS.CARACTERISTICA_GRUPO_INTERES}>
            <CaracteristicaGrupoInteres />
          </PrivateRoute>
          <PrivateRoute path={RUTAS.INDICADOR}>
            <Indicador />
          </PrivateRoute>
          <PrivateRoute path={RUTAS.EVIDENCIA_CUMPLIMIENTO}>
            <EvidenciaCumplimiento />
          </PrivateRoute>
          <PrivateRoute path={RUTAS.ESCUELA}>
            <Escuela />
          </PrivateRoute>
          <PrivateRoute path={RUTAS.PROGRAMAS_ACADEMICOS}>
            <ProgramasAcademicos />
          </PrivateRoute>
          <PrivateRoute path={RUTAS.ENCUESTAS} exact>
            <Encuesta />
          </PrivateRoute>
          <PrivateRoute path={RUTAS.DETALLE_ENCUESTA} exact>
            <DetalleEncuesta />
          </PrivateRoute>
          <PrivateRoute path={RUTAS.VISTA_PREVIA_ENCUESTA} exact>
            <PrevisualizacionEncuesta />
          </PrivateRoute>
          <PrivateRoute path={RUTAS.PREGUNTAS}>
            <Preguntas />
          </PrivateRoute>
          <Route path='*'>
            <Redirect to={RUTAS.LOGIN} />
          </Route>
        </Switch>
      </AutoEvaluacionesErrorBoundary>
    </Router>
  )
}

export default App
